var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("仓库管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/addGoodsWareHouse" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("商品仓库")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("添加仓库")]),
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.formInline1 },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品仓库" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32", placeholder: "请输入仓库名称" },
                    model: {
                      value: _vm.formInline1.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInline1, "name", $$v)
                      },
                      expression: "formInline1.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.listAxios(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm.parArray.indexOf("wareAdd") != -1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialoVisible = true
                              _vm.formInline = {}
                            },
                          },
                        },
                        [_vm._v("添加仓库")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c("p", { staticClass: "header" }, [_vm._v("管理分类")]),
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.tableData.list } },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", type: "index", width: "50px;" },
                }),
                _c("el-table-column", {
                  attrs: { scope: "scope", label: "仓库名称", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.edit
                            ? _c("el-input", {
                                attrs: { maxlength: "32" },
                                model: {
                                  value: scope.row.name,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "name", $$v)
                                  },
                                  expression: "scope.row.name",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    scope: "scope",
                    label: "破损仓库名称",
                    width: "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.edit
                            ? _c("el-input", {
                                attrs: { maxlength: "52" },
                                model: {
                                  value: scope.row.damagedName,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "damagedName", $$v)
                                  },
                                  expression: "scope.row.damagedName",
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(scope.row.damagedName)),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { scope: "scope", label: "仓库管理员", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.edit
                            ? _c("el-input", {
                                attrs: { maxlength: "52" },
                                model: {
                                  value: scope.row.keeper,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "keeper", $$v)
                                  },
                                  expression: "scope.row.keeper",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(scope.row.keeper))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "更新时间", prop: "createdTime" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "optain" }, [
                            _vm.parArray.indexOf("locationCode") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.tolocation(scope.row)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("库位")])]
                                )
                              : _vm._e(),
                            !scope.row.edit &&
                            _vm.parArray.indexOf("warebc") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        scope.row.edit = !scope.row.edit
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("编辑")])]
                                )
                              : _vm._e(),
                            scope.row.edit &&
                            _vm.parArray.indexOf("warebc") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.fixHouser(scope.row)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("保存")])]
                                )
                              : _vm._e(),
                            scope.row.edit &&
                            _vm.parArray.indexOf("warebc") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        ;(scope.row.edit = !scope.row.edit),
                                          (scope.row.name = scope.row.name1),
                                          (scope.row.keeper =
                                            scope.row.keeper1),
                                          (scope.row.damagedName =
                                            scope.row.damagedName1)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("取消")])]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("wareDelect") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.delect(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("删除")])]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("p", { staticStyle: { height: "30px" } }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialoVisible,
            "append-to-body": true,
            title: "新增仓库",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialoVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "right",
                    "label-width": "80px",
                    model: _vm.formInline,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "仓库名称" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "30" },
                        model: {
                          value: _vm.formInline.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "name", $$v)
                          },
                          expression: "formInline.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "破损仓库" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "30" },
                        model: {
                          value: _vm.formInline.damagedName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "damagedName", $$v)
                          },
                          expression: "formInline.damagedName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "管理员" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "30" },
                        model: {
                          value: _vm.formInline.keeper,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "keeper", $$v)
                          },
                          expression: "formInline.keeper",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.dialoVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }